import { ProductVersionsProvider } from 'presentation/app/context/product-versions-provider';
import { ServiceProvider } from 'presentation/app/hooks/useService';
import { store } from 'presentation/config/store';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

import App from './App';
import { AuthProvider } from './presentation/app/hooks/useAuth';
import { LoadingProvider } from './presentation/app/hooks/useLoading';
import reportWebVitals from './reportWebVitals';

// eslint-disable-next-line import-helpers/order-imports
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
// eslint-disable-next-line import-helpers/order-imports
import { FiltersProvider } from 'presentation/app/modules/Dashboard/hooks/useFilters';

// eslint-disable-next-line import-helpers/order-imports
import { WebSocketProvider } from './presentation/app/hooks/WebSocketProvider';
import { getEnv } from 'shared/get-env';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <ServiceProvider>
    <Provider store={store}>
      <SkeletonTheme baseColor="#ffffff48" highlightColor="#ffffff6c">
        <BrowserRouter basename={getEnv('REACT_APP_PUBLIC_URL')}>
          <FiltersProvider>
            <AuthProvider>
              <WebSocketProvider>
                <LoadingProvider>
                  <ProductVersionsProvider>
                    <App />
                  </ProductVersionsProvider>
                </LoadingProvider>
              </WebSocketProvider>
            </AuthProvider>
          </FiltersProvider>
        </BrowserRouter>
      </SkeletonTheme>
    </Provider>
  </ServiceProvider>,
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
